export default __webpack_public_path__ + "static/media/player.c96176ce.jpg";